<script>
export default {
  name: "IconGreenSpelling"
};
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor" fill-rule="nonzero">
      <path d="M12.363 0H0v16h16V7.52h-1.413v7.068H1.412V1.412h10.95z" />
      <path d="M15.887 3.045l-.993-.996-6.551 6.57L4.78 5.044l-.994.995 4.557 4.571z" />
    </g>
  </svg>
</template>
